import Yaafloop from "yaafloop"

export default new class Loop {
    start(func) {
        return Yaafloop((delta) => {
            this.delta = delta
            func(delta)
        })
    }
}
